import { URL_CONFIG } from '@shared/configs/environment';
import axios from 'axios';

const axiosApi = axios.create({
    baseURL: URL_CONFIG.API.url,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Expose-Headers': 'Content-Disposition',
        'Pragma': 'no-cache'
    }
});

axiosApi.interceptors.response.use(
    response => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.clear();
            localStorage.setItem('logout-event', Date.now().toString());
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export { axios, axiosApi };
